import axios from "axios";

export const state = {
    checkofflists: [],
};

export const getters = {
    checkofflists: state => state.checkofflists,
};

export const mutations = {
    setCheckoffLists(state, newValue) {
        state.checkofflists = newValue
    },
};

export const actions = {
    async fetchCheckoffLists({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/checkoff-lists/${fyear}`).then(res => {
            commit('setCheckoffLists', res.data.checkofflists);
        })
    },
};
